import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { UserAuthInterface } from '@app/shared/auth/interfaces/auth.interface';
import { LocalStorageService } from '@app/shared/services/local-storage/local-storage.service';
import { JwtHelperService } from '@auth0/angular-jwt';

@Injectable()
export class AuthService {
  private jwtHelper: JwtHelperService;

  public get user(): UserAuthInterface {
    return this._user;
  }

  public set user(user: UserAuthInterface) {
    this._user = user;
  }

  public get token(): string {
    return this._token || this.localStorageService.getToken();
  }

  public set token(token: string) {
    this._token = token;
    this.localStorageService.setToken(token);
  }

  public get isAuthenticated(): boolean {
    return Boolean(this.token);
  }

  public get isOnboarded(): boolean {
    return this.user && this.user.onboarded;
  }

  private _user: UserAuthInterface;
  private _token: string;

  constructor(
    private readonly localStorageService: LocalStorageService,
    private readonly configService: ConfigService,
  ) {
    this.decodeToken();
  }

  public getUser(): UserAuthInterface {
    if (typeof this.user === 'undefined') {
      this.decodeToken();
    }
    return this.user;
  }

  public decodeToken(): void {
    this.token = this.localStorageService.getToken();
    this.jwtHelper = new JwtHelperService();
    if (this.token) {
      this.user = this.jwtHelper.decodeToken(this.token);
    }
  }

  public decodeGivenToken(token: string): void {
    this.token = token;
    if (!this.jwtHelper) {
      this.jwtHelper = new JwtHelperService();
    }
    this.user = this.jwtHelper.decodeToken(this.token);
  }

  public getConfig(type: string): Promise<any> {
    return this.configService.fetchClientConfig(type);
  }

  public invalidateUser(): void {
    this.user = null;
  }

}
